'use client';

import { useGlobalClientContext } from '../../../modules/common/GlobalClientContext';
import React from 'react';
import { I18nResKeys } from '@altus-ui/i18n/messages/i18n-types';

export default function ConsentReceivePromotionalV1() {
  const {
    i18nHelper: { t }
  } = useGlobalClientContext();
  const getText = (key: string) => t(key as I18nResKeys, {});

  return (
    <div className="flex flex-col gap-3xl not-italic">
      <p className="font-regular text-sm text-primary leading-md whitespace-pre-wrap">
        {getText('consent.to.promotional_content')}
      </p>
    </div>
  );
}
